// extracted by mini-css-extract-plugin
export default {"container":"CustomButton_container__uERKq","iconContainer":"CustomButton_iconContainer__OAgLF","dark":"CustomButton_dark__yy6ya"};